<template>
  <div class="accout-overview-header">
    <el-row>
      <el-col :span="24">
        <div class="page-title">
          {{ $t('merchant.account_balance') }}
        </div>
      </el-col>
    </el-row>
    <div class="accout-overview-header-content">

      <div class="num-container">
        <div class="txt">{{ $t('merchantAccount.balance_available') }}
          <!-- <el-tooltip placement="top">
            <div slot="content" style="width: 300px">
              <span>{{ $t('tips.dashboard_balance_question') }}</span>
            </div>
            <span> <svg-icon icon-class="icon-font-question" class="icon-question" /></span>
          </el-tooltip> -->
        </div>
        <div class="num">
          {{ $store.getters.currency }}
          {{ balanceInfo.balance | toDivideWithDot }}
          <el-tooltip placement="bottom">
            <div slot="content">
              <span>{{ $t('tips.dashboard_balance_number') }}  {{ $store.getters.currency }}{{ balanceInfo.available_withdraw | toDivideWithDot }}</span>
            </div>
            <span>  <svg-icon icon-class="icon-font-warning" class="icon-warning" /></span>
          </el-tooltip>

        </div>
      </div>

      <div class="num-container">
        <div class="txt">{{ $t('merchantAccount.amount_in_transit') }}</div>
        <div class="num">
          {{ $store.getters.currency }}
          {{ balanceInfo.fund_settlement_amount | toDivideWithDot }}
        </div>
      </div>

      <div class="num-container" style="padding:0">
        <div class="num-adb-container">
          <div class="txt">{{ $t('merchantAccount.amount_adb') }}</div>
          <div class="num">
            {{ $store.getters.currency }}
            {{ balanceInfo.adb_amount | toDivideWithDot }}
          </div>
        </div>
      </div>
      <div class="num-container">
        <el-button v-if="withdrawInfo.withdraw_type === 1" style="margin: 7px; width: 103px;" type="primary" @click="onClickWithDrawBtn">
          {{ $t('merchantAccount.cash_out') }}
        </el-button>
        <el-button class="filter-btn-add" style="margin: 7px; width: 208px;" type="primary" @click="onClickBalanceDetailTxt">{{ $t('data.balance_details') }}</el-button>

        <!-- <el-button type="info" plain @click="onClickTransBtn">
{{ $t('data.transfer') }}
</el-button> -->

      </div>
    </div>
    <WithdrawModal ref="withdrawModalRef" :withdraw-fee="withdrawFee" :merchant-info="merchantInfo" :balance-info="balanceInfo" @get-merchant-info="getMerchantInfo" />
  </div>
</template>

<script>
import { fetchMerchantInfo } from '@/api/merchant-manage/merchant-manage'
import { fetchWithdrawType, fetchNeedSupplementStatus } from '@/api/system/system.js'
export default {
  name: 'Merchant_Withdraw_Recharge',
  components: {
    WithdrawModal: () => import('../Modal/WithdrawModal.vue')
  },
  data() {
    return {
      balanceInfo: { balance: 0 },
      withdrawStatus: '',
      merchantInfo: {},
      withdrawInfo: {},
      withdrawFee: null,
      isNeedSupplementStatus: false,
      merchant: this.$store.getters.userInfo.merchant ?? {}
    }
  },
  created() {
    this.getMerchantInfo()
    this.getWithdrawType()
    // this.getNeedSupplementStatus()
    // this.getWithdrawStatus()
  },
  methods: {
    getWithdrawStatus() {
      fetchWithdrawStatus().then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          this.withdrawStatus = data.withdraw_status
        }
      })
    },
    getWithdrawType() {
      fetchWithdrawType().then(res => {
        const { code, data } = res
        if (code === 10000 && data) {
          this.withdrawInfo = data
        }
      })
    },
    getNeedSupplementStatus() {
      fetchNeedSupplementStatus().then(res => {
        const { code, data } = res
        this.isNeedSupplementStatus = data
      })
    },
    getMerchantInfo() {
      fetchMerchantInfo().then(res => {
        const { merchant = {}, balance } = res.data
        const { merchant_basic_info, withdraw_fee_status } = merchant
        this.balanceInfo = balance || {}
        this.merchantInfo = { ...merchant_basic_info, withdraw_fee_status }
      })
    },
    onClickBalanceDetailTxt() {
      this.$router.push({ name: 'Financial_Manage_Agent_Balance_Detail' })
    },
    onClickRechargeBtn() {
      this.$refs.rechargeModalRef.showModal()
    },
    onClickWithDrawBtn() {
      // if (this.isNeedSupplementStatus) {
      //   this.$message.warning('Supplementary information is not passed!')
      //   return
      // }
      // if (this.withdrawStatus !== 1) {
      //   this.$message.warning('You are not allowed to cash out')
      //   return
      // }
      this.$refs.withdrawModalRef.changModalStatus(true)
    },
    onClickTransBtn() {
      this.$refs.transModalRef.changModalStatus(true)
    }
  }
}
</script>
<style scoped lang="scss">

.accout-overview-header{
  margin-bottom: 24px;
  &-content{
    display: flex;
    width: 100%;
    .num-container{
      flex: 1;
      padding: 24px;
      border-radius: 8px;
      background: #FFF;
      box-shadow: 0px 40px 11px 0px rgba(114, 128, 187, 0.00), 0px 26px 10px 0px rgba(114, 128, 187, 0.02), 0px 14px 9px 0px rgba(114, 128, 187, 0.07), 0px 6px 6px 0px rgba(114, 128, 187, 0.12), 0px 2px 4px 0px rgba(114, 128, 187, 0.14);
      &:not(:last-child){
        margin-right: 24px;
      }
      .txt{
        margin-bottom: 16px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.2;
        color: #4B5567;
      }
      .num{
        font-size: 24px;
        font-weight: 600;  font-family: 'Poppins-SemiBold';
        line-height: 1.2;
        color:  #488CE8;
      }
    }

    .num-adb-container{
      padding: 24px;
      height: 100%;
      background: url('~@/assets/ezpay/bg_transfer.png') right bottom no-repeat;
      background-size: 116px 116px;
    }

  }
  .line{
    display: inline-block;
    margin:0 24px;
    width: 1px;
    height: 60px;
    background:#D3D7DF;
    vertical-align: -4px;
  }
  .line2{
    display: inline-block;
    margin:0 15px;
    width: 1px;
    height: 32px;
    background:#D3D7DF;
  }
  .balance-detail-txt{
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
    cursor: pointer;
    text-decoration: underline;
  }
}

.balance-operate{
  display: flex;
  align-items: center;
}
.icon-question{
  font-size: 11px;
  position: relative;
  top: -2px;
  cursor: pointer;
}
.icon-warning{
  font-size: 15px;
  position: relative;
  top: -4px;
  cursor: pointer;
}

</style>

